export default "__VITE_PUBLIC_ASSET__b38f8475__"